import { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import PrescreenRichText from "./preescreenRichText";

export type PrescreenProps = {
  readOnly: boolean;
  prescreenMessageResponse: string | null;
  exceptionLeverageRequest: string | null;
  exceptionLeverageResponse: string | null;
  isManualQuote: boolean;
  projectDescription?: string;
  onSubmit: (prescreenMessage: string, exceptionMessage: string) => void;
  onCancel: () => void;
};

export const Prescreen = observer((props: PrescreenProps) => {
  const {
    readOnly,
    prescreenMessageResponse,
    exceptionLeverageRequest,
    exceptionLeverageResponse,
    isManualQuote,
    projectDescription,
    onSubmit,
    onCancel,
  } = props;

  const [prescreenMessage, setPrescreenMessage] = useState(prescreenMessageResponse);
  const [exceptionMessage, setExceptionMessage] = useState(exceptionLeverageResponse);

  const submitPrescreen = () => {
    onSubmit(prescreenMessage ?? null, exceptionMessage ?? null);
  };

  const cancelPrescreen = () => {
    onCancel();
  };

  return (
    <Grid container>
      <Grid container item xs={12} alignItems="center" spacing={2}>
        <Grid item xs={12}>
          <PrescreenRichText
            onChange={setPrescreenMessage}
            value={prescreenMessage}
            readOnly={readOnly}
          />

          {projectDescription && (
            <>
              <Grid item xs={12} className='match-padding'>
                <p style={{ marginBottom: '0px' }}>Additional Comments:</p>
              </Grid>
              <Grid item xs={12} className='match-padding'>
                <textarea
                  className="form-control-disabled"
                  value={projectDescription}
                  disabled={true}
                  data-test-id={'projectDescription'}/>
                </Grid>
            </>
          )}

          {exceptionLeverageRequest && !isManualQuote && (
            <>
              <Grid item xs={12} className='match-padding'>
                <textarea
                  className="form-control-disabled"
                  value={exceptionLeverageRequest}
                  disabled={true}
                  data-test-id={'exceptionLeverageRequest'}/>
              </Grid>
              <Grid item xs={12} className='match-padding'>
                Please give an answer to the exception leverage:
              </Grid>
              <Grid item xs={12}>
                <PrescreenRichText
                  onChange={setExceptionMessage}
                  value={exceptionMessage}
                  readOnly={readOnly}
                />
              </Grid>
            </>
          )}

          <Grid container item className="buttonsContainer" justifyContent="flex-end" xs={12} spacing={2}>
            <Grid item xs={2}>
              <Button className="button" variant="outlined" color="primary" fullWidth onClick={cancelPrescreen}>
                Cancel
              </Button>
            </Grid>

            {!readOnly && (
              <Grid item xs={2}>
                <Button
                  className="button"
                  variant='outlined'
                  color='secondary'
                  fullWidth
                  onClick={submitPrescreen}
                  disabled={prescreenMessage.length === 0}>
                  Submit
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid></Grid>
    </Grid>
  );
});

export default Prescreen;